import {
  CollectionEntryFlagFieldsFragmentDoc,
  isType,
} from '@spotify/confidence-graphql';
import { createCollectionEntryExtension } from '@spotify/plugin-confidence-collections-react';

import { flagsPlugin } from '../plugin';
import { flagRouteRef } from '../routes';

export const FlagCollectionEntryExtension = flagsPlugin.provide(
  createCollectionEntryExtension({
    id: 'flag',
    resourceType: 'Flag',
    routeRef: flagRouteRef,
    fragment: CollectionEntryFlagFieldsFragmentDoc,
    predicate: ({ resource }) => isType(resource, 'FlagsAdminV1Flag'),
    render: () => null,
  }),
);
